import React from 'react'
import styled from 'styled-components'
import theme from '../../common/theme'
import { useHistory } from 'react-router'
import Icon from '../../common/Icon'

const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${ theme.palette.dark_blue };
  font-size: 20px;
  line-height: 23px;
  font-weight: bold;
  align-items: center;
  margin: 10px 20px 40px; 20px;
  .back-btn{
    cursor: pointer;
    margin-top: 2px;
    fill: ${ theme.palette.black };
  }
`

function PageHeader({ children, prevLink, onPrevious }) {
  const history = useHistory()
  return (
    <PageHeaderContainer>
      {
        (prevLink || onPrevious) &&
        <Icon className="back-btn"
              name="chevron_left"
              onClick={ () => {
                onPrevious && onPrevious()
                prevLink && history.push(prevLink)
              } }
        />
      }
      { children }
    </PageHeaderContainer>
  )
}

export default PageHeader
